var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tooltip"},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"tooltip-block",domProps:{"innerHTML":_vm._s(_vm.translate(message))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }